import { render, staticRenderFns } from "./AdminMainWrapper.vue?vue&type=template&id=2979e1c9&"
import script from "./AdminMainWrapper.vue?vue&type=script&lang=js&"
export * from "./AdminMainWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AdminMainWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports